import { lazyLoad } from 'utils/loadable';

export const AdminFormPage = lazyLoad(
  () => import('./index'),
  module => module.AdminFormPage,
);
